import React, { type FC, type HTMLAttributes } from "react";
import * as Card from "@wbly/ui/components/Card";
import { Button } from "@wbly/ui";
import styles from "./ProductCard.module.css";

// This card can be used as a client component
// and as a server component. The only difference is that
// the server component be using the Astro <Image> component
// while the client one will use the <img> tag. Use the image or
// imageUrL prop accordingly
export type ProductCardProps = {
  title: string;
  href: string;
  key?: string;
  description?: string;
  image?: React.ReactNode;
  imageUrl?: string;
  price?: string;
  ageRange?: string;
  isClientSide?: boolean;
  as?: "li" | "div";
  ctaLabel?: string;
} & HTMLAttributes<HTMLElement> & {
    [key: `data-insights-${string}`]: string | number;
  };

const {
  anchor,
  heading,
  subtitle,
  age,
  content,
  priceText,
  cardWrapper,
  footer,
} = styles;

export const ProductCard: FC<ProductCardProps> = (props) => {
  const {
    id,
    title,
    href,
    description,
    image,
    price,
    ageRange,
    imageUrl,
    as = "li",
    ctaLabel,
    "data-insights-object-id": dataInsightsObjectId,
    "data-insights-position": dataInsightsPosition,
    "data-insights-query-id": dataInsightsQueryId,
  } = props;

  return (
    <Card.Root
      id={id}
      as={as}
      className={cardWrapper}
      data-insights-object-id={dataInsightsObjectId}
      data-insights-position={dataInsightsPosition}
      data-insights-query-id={dataInsightsQueryId}
    >
      <Card.Media className={styles.image}>
        {/* TODO: create storybook docs and code examples */}
        {/* This card can be used as a client component
        and as a server component.The server component be using 
        the Astro <Image> component while the client one will use the <img> tag. 
        Please use the `image` or `imageUrl` props accordingly */}

        {imageUrl ? <img src={imageUrl} alt={title} loading="lazy" /> : image}
      </Card.Media>
      <a
        aria-label={title}
        className={anchor}
        id={`card-anchor-${id}`}
        href={href}
      >
        {title}
      </a>

      <Card.Content className={content}>
        <h5 className={heading}>{title}</h5>
        {description && <p className={subtitle}>{description}</p>}
        {ageRange && <p className={age}>{ageRange}</p>}
        {price && <p className={priceText}>{price}</p>}
      </Card.Content>

      {ctaLabel && (
        <Card.Footer className={footer}>
          <Button>{ctaLabel}</Button>
        </Card.Footer>
      )}
    </Card.Root>
  );
};
